import { createFileRoute } from '@tanstack/react-router'

import { VersionsPage } from '@repo/common/components/VersionsPage'

// do to TanStack Router auto generate file routes
// prettier-ignore
export const Route = createFileRoute('/versions')({
  component: VersionsPage,
})
